const EVT_NS = '.scheduleModal';

export function openSchedule() {
    window.$('#showScheduleModal').modal('show');
}

export function closeSchedule() {
    window.$('#showScheduleModal').modal('hide');
}

export function initScheduleModal() {
    const $ = window.$;
    $(document)
        .off('click' + EVT_NS, '[data-action="close-schedule-modal"]')
        .on('click' + EVT_NS, '[data-action="close-schedule-modal"]', function (e) {
            e.preventDefault();
            closeSchedule();
        });
}
